(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  function positionCollectionPromos() {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    const products = grid.querySelectorAll('.product-grid__item:not(.product-grid__item--promo)');

    [...grid.querySelectorAll('.product-grid__item--promo')]
      .sort((a, b) => a.dataset.promoPosition - b.dataset.promoPosition)
      .forEach((promo) => {
        const target = products[promo.dataset.promoPosition - 1];
        if (target) target.insertAdjacentElement('afterend', promo);
        else grid.appendChild(promo);
      });
  }

  function watchCollectionPromoPlacement() {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    new MutationObserver((_, observer) => {
      positionCollectionPromos();
      observer.disconnect();
    }).observe(grid, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', positionCollectionPromos);
  document.addEventListener('shopify:section:load', positionCollectionPromos);
  document.addEventListener('filter:update', watchCollectionPromoPlacement);

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
          
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
